import { SxProps, Theme } from "@mui/material";

export const getButtonStyles =
  (isActive: boolean): SxProps<Theme> =>
  (theme: Theme) => ({
    borderRadius: "999px",
    textTransform: "none",
    px: "8px",
    py: "4px",
    fontWeight: 500,
    fontSize: "0.95rem",
    backgroundColor: isActive ? "#06B6D4" : theme.palette.panelInfo.tab.bg,
    color: isActive ? "#fff" : theme.palette.panelInfo.tab.color,
    "&:hover": {
      backgroundColor: isActive ? "#06B6D4" : theme.palette.panelInfo.tab.bg,
    },
    fontFamily: '"Red Hat Display"',
    whiteSpace: "nowrap",
    flexShrink: 0,
  });

export const lessonContainerStyles: SxProps<Theme> = (theme) => ({
  background: theme.palette.panelInfo.message.bg,
  p: 2,
  borderRadius: 1,
  cursor: "pointer",
  transition: "background-color 0.2s ease-in-out",
  "&:hover": {
    backgroundColor: theme.palette.panelInfo.message.bgHover,
  },
});

export const selectStyles: SxProps<Theme> = (theme) => ({
  width: 120,
  "&:hover .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-notchedOutline":
    {
      borderColor: theme.palette.panelInfo.selector.borderColor,
    },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D4",
    color: theme.palette.panelInfo.selector.color,
  },
});

export const selectCompetenceStyles: SxProps<Theme> = (theme) => ({
  width: "100%",
  "&:hover .MuiOutlinedInput-notchedOutline, .MuiOutlinedInput-notchedOutline":
    {
      borderColor: theme.palette.panelInfo.selector.borderColor,
    },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D4",
    color: theme.palette.panelInfo.selector.color,
  },
});

export const markdownBoxStyles: SxProps = {
  fontFamily: '"Red Hat Display", sans-serif',
};

export const messageBoxStyles: SxProps<Theme> = (theme) => ({
  background: theme.palette.panelInfo.message.bg,
  p: 2,
  borderRadius: 1,
  cursor: "pointer",
  transition: "background-color 0.2s ease-in-out",
  "&:hover": {
    backgroundColor: theme.palette.panelInfo.message.bgHover,
  },
});
export const containerListStyles: SxProps = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
};

export const imageCollectionBoxStyles: SxProps = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: 1,
};
